<div class="d-flex" style="border-radius: 10px;background-color:{{myColor1}}; width: 100%; height: 6rem; cursor: pointer;">

    <div class="w-75 text-start p-1" style="height: 6rem;">
        <h6><strong>{{title}}</strong></h6>
        <p>{{content}}</p>
    </div>
    <div class="w-25 pt-2">
            <span class="p-1" style="color:{{myColor2}}; ">{{date    | date:"dd-MM-yyyy"}}</span>
    </div>
</div>